import { Component, OnInit } from '@angular/core';
import { CompanyDetails } from '../../model/company-details.model';
import { CompanyDetailsService } from '../../service/company-details.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/service/auth.service';
import { Observable } from 'rxjs';
import { User } from 'src/app/model/user.model';
@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.css']
})
export class CompanyDetailsComponent implements OnInit {

  companyDetails: CompanyDetails;
  currentUser: User;

  constructor(private companyDetailsService: CompanyDetailsService,private activedRoute: ActivatedRoute,private router: Router,private authService: AuthService) {

  }


  ngOnInit() {
      this.companyDetailsService
      .GetCompanyDetails()
      .subscribe(data => this.companyDetails = data as CompanyDetails);

      this.authService.currentUser.subscribe(x => this.currentUser = x);

  }

}
